import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { EmojiAvatar, StatusTag } from '@factorialco/factorial-one-react/dist/experimental'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useActiveMarkets } from 'modules/benefits/hooks/useActiveMarkets'
import { type BenefitListing, getBenefitsList } from 'modules/benefits/lib/benefitListings'

import { WizardData } from '../types'

export const BenefitsSummaryStep = ({
  data: _data,
  onDataChanged: _onDataChanged,
}: WizardStepRenderParams<WizardData>) => {
  const { company } = useCurrentSession()

  const { activeMarkets } = useActiveMarkets()

  const benefitsList: BenefitListing[] = useUnsafeMemo(
    () =>
      activeMarkets?.flatMap((market) =>
        getBenefitsList(market).filter((benefit) => benefit.benefitStatus === 'active')
      ) ?? [],
    [activeMarkets]
  )

  useEffect(() => {
    track(trackingEvents.benefits.userLandsInBenefitsActivationOnboarding, {
      companyId: company.id,
    })
  }, [company.id])

  return (
    <Box flexDirection="column" position="relative" justifyContent="center">
      <Box flexDirection="column" paddingBottom="s20">
        <Text.Normal weight="semibold" color="grey1000" size="400">
          {i18n.t('benefits.tabs.employees.activation_results.modal.review_benefits.step_title')}
        </Text.Normal>
        <Text.Normal weight="normal" color="grey800" size="300">
          {i18n.t('benefits.tabs.employees.activation_results.modal.review_benefits.description')}
        </Text.Normal>
      </Box>
      <Box flexDirection="column">
        {benefitsList.map((benefit) => (
          <Box key={benefit.title} paddingBottom="s12">
            <EmojiAvatar emoji={benefit.emoji} size="md" />

            <Box flexDirection="column" paddingTop="s12" alignItems="flexStart">
              <Text.Normal weight="semibold" color="grey1000" size="300">
                {benefit.title}
              </Text.Normal>

              <Text.Normal weight="normal" color="grey800" size="200">
                {benefit.reviewDescription || benefit.description}
              </Text.Normal>
            </Box>

            {benefit.benefitStatus === 'pending' && (
              <Box flexDirection="row" paddingTop="s8">
                <StatusTag
                  text={i18n.t(
                    'benefits.tabs.employees.activation_results.modal.review_benefits.benefits_list.tags.coming_soon'
                  )}
                  variant="info"
                />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
